

export default {

    name:'logo',
    created() {

        let t = this;

        if(t.U.id){
            location.replace('/#/signIn');
        }

        else if(window.Capacitor){
            location.replace('/#/signIn');
        }

        console.log(2);
        
        
    },
    activated() {

        let t = this;

    },
    unmounted() {
    },
    methods: {
    },
    data() {
        return {

        };
    },
};
